// Import image path - can be mocked for testing
export const backgroundImagePath =
  process.env.NODE_ENV === 'test'
    ? 'test-image-stub'
    : require('../../assets/img/basic-background.jpg');
